import { useTranslation } from "react-i18next";

import { Button } from "@/components/Interface/Button/Button";
import { Modal } from "@/components/Interface/Modal/Modal";
import { ButtonGroupFlexBox } from "@/components/Layout/ButtonGroupFlexBox/ButtonGroupFlexBox";

type Props = {
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
  isConfirming?: boolean;
};

export const EsimInfoModal = ({
  onConfirm,
  onClose,
  isConfirming = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("portal:add-device.esimInfoModal.title")}
      onClose={onClose}
      hasScroll={false}
      variant="dark"
    >
      <div className="flex flex-col gap-6">
        <p className="text-body-base text-foreground-primary-inverse">
          {t("portal:add-device.esimInfoModal.description")}
        </p>

        <div className="flex flex-col gap-2 rounded-md bg-surface-quaternary-inverse p-4">
          <h3 className="text-body-lg font-semibold text-foreground-primary-inverse">
            {t("portal:add-device.esimInfoModal.requirementTitle")}
          </h3>
          <p className="text-body-base text-foreground-primary-inverse">
            {t("portal:add-device.esimInfoModal.requirementText")}
          </p>
          <ul className="list-outside list-disc space-y-2 pl-4 text-body-base text-foreground-primary-inverse">
            <li>{t("portal:add-device.esimInfoModal.benefits.instant")}</li>
            <li>{t("portal:add-device.esimInfoModal.benefits.noSwap")}</li>
            <li>{t("portal:add-device.esimInfoModal.benefits.multiTariff")}</li>
          </ul>
        </div>

        <ButtonGroupFlexBox
          className="!mt-0"
          rightAligned
          forceButtonWidth
          primaryButton={
            <Button
              variant="primary"
              inverted
              loading={isConfirming}
              onClick={() => void onConfirm()}
            >
              {t("portal:add-device.esimInfoModal.confirm")}
            </Button>
          }
          secondaryButton={
            <Button
              variant="secondary"
              inverted
              disabled={isConfirming}
              onClick={onClose}
            >
              {t("portal:add-device.esimInfoModal.cancel")}
            </Button>
          }
        />
      </div>
    </Modal>
  );
};
